import React from "react"
import { SearchContextProvider } from "./src/context/SearchContext"
import { FormContextProvider } from "./src/context/FormContext"
import { ConsentProvider } from "./src/context/ConsentContext"

const wrapRootElement = ({ element }) => (
  <SearchContextProvider>
    <FormContextProvider>
      <ConsentProvider>{element}</ConsentProvider>
    </FormContextProvider>
  </SearchContextProvider>
)

export { wrapRootElement }

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

const GTM_ID = "GTM-PM3K98Z"

const loadGtm = () => {
  if (typeof window === "undefined" || window.__GTM_LOADED__) return
  window.__GTM_LOADED__ = true

  window.dataLayer = window.dataLayer || []

  // Push sanitized page data before the GTM container loads so that the
  // default `Page URL` variable does not leak query strings or fragments.
  window.dataLayer.push({
    event: "consent_initialized",
    pageUrl:
      window.location.origin + window.location.pathname,
    pagePath: window.location.pathname,
  })

  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  })

  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
  document.head.appendChild(script)
}

export const onClientEntry = () => {
  if (typeof window === "undefined") return

  // Initialize dataLayer and a global gtag shim early so that GTM custom HTML
  // tags (e.g. Consent Mode updates) can use gtag() before the GTM container
  // finishes loading its own internals.
  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    window.dataLayer.push(arguments)
  }

  // Expose a loader that the ConsentContext can call once consent is granted.
  window.__RB_LOAD_TRACKING__ = () => {
    loadGtm()
  }
}
